import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';
import classNames from 'classnames/bind';
import React from 'react';
import LoadingBasic from './LoadingBasic.js';
import LoadingCube from './LoadingCube.js';
import { LOADING_IMAGE } from '../../constants/loading.js';
import style from './Loading.module.scss.js';

var cx = _bindInstanceProperty(classNames).call(classNames, style);
/**
 * 로딩 컴포넌트
 * - 로딩 이미지로 LOADING_IMAGE.CUBE와 LOADING_IMAGE.BASIC 두 가지 타입을 제공합니다.
 *
 * ```jsx
 * <Loading
 *    mainText={(
 *      <>
 *          신용정보와 사업자정보를
 *          <br />
 *          확인하고 있습니다
 *      </>
 *    )}
 *    subText={(
 *       <>
 *          대표자 명의 변경 등의 사유가 생기면
 *          <br />
 *          대출이 어려울 수 있습니다.
 *      </>
 *    )}
 *    imageType={LOADING_IMAGE.CUBE}
 * />
 * ```
 * - 로딩 이미지는 `LoadingBasic`, `LoadingCube`로 별도로 사용할 수 있습니다.
 * - @defign/asset의 commonIcons 중 `AniLoadingData`, `AniLoadingCube` 와 기능상 완전히 동일합니다.
 * - AniLoadingData, AniLoadingCube는 `deprecated` 되었습니다.
 *
 * ```jsx
 * <LoadingBasic width={38} height={10}/>
 * <LoadingCube width={112} height={112}/>
 * ```
 */
function Loading(_ref) {
  var mainText = _ref.mainText,
    subText = _ref.subText,
    _ref$isPage = _ref.isPage,
    isPage = _ref$isPage === void 0 ? false : _ref$isPage,
    _ref$imageType = _ref.imageType,
    imageType = _ref$imageType === void 0 ? LOADING_IMAGE.BASIC : _ref$imageType;
  var isBasicType = imageType === LOADING_IMAGE.BASIC;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('article', {
      'type-valign': isPage
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('image')
  }, isBasicType ? /*#__PURE__*/React.createElement(LoadingBasic, {
    width: 38,
    height: 10
  }) : /*#__PURE__*/React.createElement(LoadingCube, {
    width: 112,
    height: 112
  }), /*#__PURE__*/React.createElement("span", {
    className: cx('blind')
  }, "\uB85C\uB529 \uC774\uBBF8\uC9C0")), /*#__PURE__*/React.createElement("div", {
    className: cx('area', isBasicType ? "basic" : subText ? "cube" : "cube-single")
  }, mainText && /*#__PURE__*/React.createElement("strong", {
    className: cx('main-text')
  }, mainText), subText && /*#__PURE__*/React.createElement("p", {
    className: cx('sub-text')
  }, subText)));
}

export { Loading as default };
